import { UseCaseInteractor } from '../../../kernel/use-case'
import { JobRepository } from '../domain/job.repository'

export const getJobChatTokenUseCase: UseCaseInteractor<[jobRepository: JobRepository], [], string> =
  (jobRepository) => async () =>
    jobRepository.getJobChatToken()
